import styles from './LogoutModal.module.scss';
import { Button, Modal, Text } from 'components';
import { resetStateActionCreator } from 'store/actionCreators';
import { appActions } from 'store/app/slice';
import { authActions } from 'store/auth/slice';
import { useDispatch } from 'store/utils';

export const LogoutModal = () => {
  const dispatch = useDispatch();

  const handleLogoutButtonClick = async () => {
    try {
      dispatch(appActions.setAppIsLoading(true));
      await dispatch(authActions.signOut());
      dispatch(appActions.setIsModalOpened({ name: 'logout', isOpened: false }));
      dispatch(resetStateActionCreator());
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(appActions.setAppIsLoading(false));
    }
  };

  const close = () => {
    dispatch(appActions.setIsModalOpened({ name: 'logout', isOpened: false }));
  };

  return (
    <Modal title={'Logout'} onClose={close}>
      <div className={styles.content}>
        <Text type="body-big" className={styles.text}>
          Are you sure you want to log out from the system?
        </Text>
        <div className={styles.buttonGroup}>
          <Button isLink onClick={close}>
            Cancel
          </Button>
          <Button onClick={handleLogoutButtonClick}>Logout</Button>
        </div>
      </div>
    </Modal>
  );
};
